import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isReloadProjectTimeSheetRequestFailure(filter) {
      const req = getState().find((req) => matchRequest(req, filter));

      return req ? req.request.isFailure : false;
    },
    isReloadProjectTimeSheetRequestPending(filter) {
      const req = getState().find((req) => matchRequest(req, filter));

      return req ? req.request.isPending : false;
    },
    isReloadProjectTimeSheetRequestSuccess(filter) {
      const req = getState().find((req) => matchRequest(req, filter));

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
